import React from "react";

const SettingsIcon = ({fill}: {fill?: string}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_26587_137344)">
      <path
        d="M13.3546 8.70578C13.3846 8.48078 13.3996 8.24828 13.3996 8.00078C13.3996 7.76078 13.3846 7.52078 13.3471 7.29578L14.8696 6.11078C15.0046 6.00578 15.0421 5.80328 14.9596 5.65328L13.5196 3.16328C13.4296 2.99828 13.2421 2.94578 13.0771 2.99828L11.2846 3.71828C10.9096 3.43328 10.5121 3.19328 10.0696 3.01328L9.79959 1.10828C9.76959 0.928281 9.61959 0.800781 9.43959 0.800781H6.55959C6.37959 0.800781 6.23709 0.928281 6.20709 1.10828L5.93709 3.01328C5.49459 3.19328 5.08959 3.44078 4.72209 3.71828L2.92959 2.99828C2.76459 2.93828 2.57709 2.99828 2.48709 3.16328L1.05459 5.65328C0.964594 5.81078 0.994594 6.00578 1.14459 6.11078L2.66709 7.29578C2.62959 7.52078 2.59959 7.76828 2.59959 8.00078C2.59959 8.23328 2.61459 8.48078 2.65209 8.70578L1.12959 9.89078C0.994594 9.99578 0.957094 10.1983 1.03959 10.3483L2.47959 12.8383C2.56959 13.0033 2.75709 13.0558 2.92209 13.0033L4.71459 12.2833C5.08959 12.5683 5.48709 12.8083 5.92959 12.9883L6.19959 14.8933C6.23709 15.0733 6.37959 15.2008 6.55959 15.2008H9.43959C9.61959 15.2008 9.76959 15.0733 9.79209 14.8933L10.0621 12.9883C10.5046 12.8083 10.9096 12.5683 11.2771 12.2833L13.0696 13.0033C13.2346 13.0633 13.4221 13.0033 13.5121 12.8383L14.9521 10.3483C15.0421 10.1833 15.0046 9.99578 14.8621 9.89078L13.3546 8.70578ZM7.99959 10.7008C6.51459 10.7008 5.29959 9.48578 5.29959 8.00078C5.29959 6.51578 6.51459 5.30078 7.99959 5.30078C9.48459 5.30078 10.6996 6.51578 10.6996 8.00078C10.6996 9.48578 9.48459 10.7008 7.99959 10.7008Z"
        fill={fill || "#E0E0E0"}
      />
    </g>
    <defs>
      <clipPath id="clip0_26587_137344">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(-1 -1)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SettingsIcon;
